export var PaymentMethod;

(function (PaymentMethod) {
  PaymentMethod["GIFT_CARD"] = "GIFT_CARD";
  PaymentMethod["CREDIT_CARD"] = "CREDIT_CARD";
  PaymentMethod["APPLE_PAY"] = "APPLE_PAY";
  PaymentMethod["GOOGLE_PAY"] = "GOOGLE_PAY";
})(PaymentMethod || (PaymentMethod = {}));